import React, { useContext, useEffect, useState } from "react";
import AdminContext from "../../../StateContext/Application";
import { Form, Link } from "react-router-dom";
import { Chart } from "react-google-charts";
import { usePDF } from "react-to-pdf";

const CustomMisReport = () => {
  const content = useContext(AdminContext);
  const { CustomeReports } = content;
  const [form, setform] = useState({
    fromDate: "",
    toDate: "",
    tenderFee: "",
    earnestMoneyDeposit: "",
    tenderName: "",
    tenderId: "",
  });
  const [Render, Setrender] = useState([]);
  const [Anylitics, SetDataAnyaltics] = useState([]);
  const [Data, SetData] = useState([]);
  const [Register, SetRegisterations] = useState([]);
  const [LineData, SetDataLine] = useState([]);
  const { toPDF, targetRef } = usePDF({ filename: 'page.pdf' });
  useEffect(() => {
    GetData();
    console.log(Anylitics);
  }, [Anylitics]);
  async function SubmitForm() {
    try {
      let data = await CustomeReports(form);
      Setrender(data);
    } catch (error) {
      console.error(error);
    }
  }
  async function GetData() {
    try {
      const dataArray = [
        [
          Anylitics.Total_GstAmount / Anylitics.Total_Registrations +
          " per Gst || " +
          "\n" +
          Anylitics.Total_EMD / Anylitics.Total_Registrations +
          " per EMD Fee ||  " + "\n" +
          Anylitics.Total_TenderFee / Anylitics.Total_Registrations +
          " per Tender Fee || ",
          Anylitics.Total_GstAmount,
          Anylitics.Total_EMD,
          Anylitics.Total_TenderFee,
        ],
      ];
      const BarRegisteration = [
        [
          Anylitics.Tender_Name +
          "-" +
          Anylitics.Tender_ID +
          "\n" +
          Anylitics.Total_GstAmount / Anylitics.Total_Registrations +
          " per Gst" +
          "\n" +
          Anylitics.Total_EMD / Anylitics.Total_Registrations +
          " per EMD Fee" +
          "\n" +
          Anylitics.Total_TenderFee / Anylitics.Total_Registrations +
          " per Tender Fee",
          Anylitics.Total_Registrations,
        ],
      ];

      var dataLine = [["Registerations", Anylitics.Tender_Name]];

      for (let index = 0; index <= Anylitics.Total_Registrations; index++) {
        dataLine.push([index, index]);
      }
      SetDataLine(dataLine);
      dataArray.unshift([
        "Tender_Name",
        "Total_GstAmount",
        "Total_EMD",
        "Total_TenderFee",
      ]);
      BarRegisteration.unshift(["Tender_Name", "Total_Registrations"]);
      SetData(dataArray);
      SetRegisterations(BarRegisteration);
    } catch (error) {
      console.error(error);
    }
  }
  const options1 = {
    title: "Active Tenders Report Gst / Fee / Emd",
    chartArea: { width: "60%" },
    hAxis: {
      title: "Data",
      minValue: 0,
    },
    vAxis: {
      title: "Tenders",
    },
  };

  const options = {
    chart: {
      title: "Active Tenders Registerations",
    },
  };

  return (
    <div class="container" style={{ backgroundColor: "" }}>
      <h5 style={{ textAlign: "center" }}>Tender Custom Reports</h5>
      <div class="container">
        <div class="card text-center">

          <Form onSubmit={SubmitForm}>
            <div class="card-body">
              <div class="">
                <label for="searchInput" class="form-label">
                  Search By ID or Name:
                </label>
                <input
                  type="search"
                  class="form-control"
                  id="tenderName"
                  placeholder="Enter ID/Name"
                  onChange={(e) => {
                    setform({ ...form, [e.currentTarget.id]: e.target.value });
                  }}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-evenly",
                  width: "100%",
                }}
              >
                <span>
                  <label for="fromDate" class="form-label">
                    From Date:
                  </label>
                  <input
                    type="date"
                    class="form-control"
                    id="fromDate"
                    onChange={(e) => {
                      setform({
                        ...form,
                        [e.currentTarget.id]: e.target.value,
                      });
                    }}
                  />
                </span>
                <span>
                  <label for="toDate" class="form-label">
                    To Date:
                  </label>
                  <input
                    type="date"
                    class="form-control"
                    id="toDate"
                    onChange={(e) => {
                      setform({
                        ...form,
                        [e.currentTarget.id]: e.target.value,
                      });
                    }}
                  />
                </span>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-evenly",
                  width: "100%",
                }}
                hidden
              >
                <span>
                  <label for="fromDate" class="form-label">
                    Department Wise Report
                  </label>
                  <input type="text" class="form-control" id="fromDate" />
                </span>
                <span>
                  <label for="toDate" class="form-label">
                    TenderFee
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="tenderFee"
                    onChange={(e) => {
                      setform({
                        ...form,
                        [e.currentTarget.id]: e.target.value,
                      });
                    }}
                  />
                </span>
                <span>
                  <label for="toDate" class="form-label">
                    Emd Payment
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="earnestMoneyDeposit"
                    onChange={(e) => {
                      setform({
                        ...form,
                        [e.currentTarget.id]: e.target.value,
                      });
                    }}
                  />
                </span>
              </div>
              <button
                type="submit"
                class="btn btn-primary my-3 mx-3"
                style={{
                  backgroundColor: "rgb(10, 200, 150) ",
                  border: "none",
                }}
              >
                Submit
              </button>
              <button
                type="reset"
                class="btn btn-dark my-3 mx-3"
                style={{ backgroundColor: "#e73d26", border: "none" }}
              >
                Reset
              </button>
              <button onClick={() => toPDF()} className="mx-3 btn btn-danger">Download Pdf</button>
            </div>
          </Form>
        </div>
      </div>
      <div class="container">
        <select
          className="form-control"
          onChange={(e) => {
            SetDataAnyaltics(JSON.parse(e.currentTarget.value));
          }}
        >
          <option value={JSON.stringify(false)} >Select Value</option>
          {Render.map((e) => (
            <option value={JSON.stringify(e)}>{e.Tender_Name}</option>
          ))}
        </select>
        <div
          ref={targetRef}
          class="container"
          style={{ display: "grid", justifyContent: "center" }}
        >
          <Chart
            chartType="BarChart"
            width="80vw"
            height="50vh"
            data={Data}
            options={options1}
          />
          <hr />
          <Chart
            chartType="Bar"
            width="80vw"
            height="400px"
            data={Register}
            options={options}
          />
          <Chart
            chartType="Line"
            width="100%"
            height="400px"
            data={LineData}
            options={options}
          />
        </div>
      </div>
    </div>
  );
};

export default CustomMisReport;
